module.exports = __webpack_public_path__ + "static/media/petani_kode_logo.74e8bec5.png";